import {abs, epsilon} from "./math.js";

export default function(a, b) {
  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/pointEqual.js
// module id = 677
// module chunks = 0